import React from 'react';
import Header from '../../Header';
import Footer from '../../Footer';
import { TaxPlanningPage, HeroSection, ServicesSection, ApproachSection } from './CoreComponents';
import {ServiceSelector, FAQAccordion} from './InteractiveComponents';
import TaxBottomLine from './TaxBottomLine';

const TaxPlanning = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header/>
      <main className="flex-grow">
        <TaxPlanningPage>
          <HeroSection />
          <ServicesSection />
          <ApproachSection />
        </TaxPlanningPage>
        <ServiceSelector/>
        <TaxBottomLine/>
        <FAQAccordion/>
      </main>
      <Footer/>
    </div>
  );
};

export default TaxPlanning;